import React from "react";

const Social = ({ email, phone, wa }) => {
    return (
        <ul className="social-contact">
            {/* EMAIL */}
            {email && (
                <li className="social-contact__item">
                    <a href={`mailto:${email}`} className="social-contact__link">
                        <i className="fas fa-envelope"></i>
                        <span>{email}</span>
                    </a>
                </li>
            )}

            {/* PHONE */}
            {phone && (
                <li className="social-contact__item">
                    <a href={`tel:+${phone}`} className="social-contact__link">
                        <i className="fas fa-phone-alt"></i>
                        <span>{formatPhone(phone)}</span>
                    </a>
                </li>
            )}

            {/* WHATSAPP */}
            {wa && (
                <li className="social-contact__item">
                    <a
                        href={`https://wa.me/${wa}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-contact__link"
                    >
                        <i className="fab fa-whatsapp"></i>
                        <span>WhatsApp</span>
                    </a>
                </li>
            )}
        </ul>
    );
};

/* helper kecil agar nomor tampil rapi */
const formatPhone = (phone) => {
    if (phone.startsWith("62")) {
        return "0" + phone.slice(2);
    }
    return phone;
};

export default Social;
